import React from "react";

const ExclusiveTag = ({ children, disabled, ...rest }) => (
  <div
    {...rest}
    style={{
      background: `rgba(87,125,158,${disabled ? 0.05 : 0.1})`,
      ...(disabled && { opacity: 0.5 }),
      color: "#577D9E",
      padding: "3px 10px 1px 10px",
      fontSize: "10px",
      borderRadius: "4px",
      fontFamily: "Gilroy-semibold",
      textTransform: "uppercase",
      letterSpacing: "1px",
      textAlign: "center",
      display: "inline-block",
      lineHeight: "16px",
      margin: "auto",
    }}>
    {children}
  </div>
);
export default ExclusiveTag;
